import PropTypes from "prop-types"
import React from "react"
import classNames from "classnames"
import {
  faCircle as faOutlineCircle,
  faStar as faOutlineStar,
} from "@fortawesome/free-regular-svg-icons"
import { faCircle, faStar } from "@fortawesome/free-solid-svg-icons"

import Icon from "../../layout/icon"
import { BodyText, InlineText } from "../../Typography/Typography"

import {
  icon,
  middling,
  negative,
  positive,
  regulatorsRatingContainer,
  unrated,
} from "./styles.module.scss"
import useRatingCopy from "../../../utils/useRatingCopy"

const RATING_KEYS = {
  cqc: [
    "outstanding",
    "good",
    "requires_improvement",
    "inadequate",
    "not_published",
    null,
  ],
  ci: [
    "excellent",
    "very_good",
    "good",
    "adequate",
    "weak",
    "unsatisfactory",
    "not_published",
    null,
  ],
}

const RATING_ICON = {
  cqc: {
    outstanding: faStar,
    good: faCircle,
    requires_improvement: faCircle,
    inadequate: faCircle,
    not_published: faOutlineCircle,
    null: faOutlineCircle,
  },
  ci: {
    excellent: faStar,
    very_good: faOutlineStar,
    good: faCircle,
    adequate: faOutlineCircle,
    weak: faCircle,
    unsatisfactory: faCircle,
    not_published: faOutlineCircle,
    null: faOutlineCircle,
  },
}

const RATING_ICON_CLASS = {
  cqc: {
    outstanding: positive,
    good: positive,
    requires_improvement: middling,
    inadequate: negative,
    not_published: unrated,
    null: unrated,
  },
  ci: {
    excellent: positive,
    very_good: positive,
    good: positive,
    adequate: positive,
    weak: middling,
    unsatisfactory: negative,
    not_published: unrated,
    null: unrated,
  },
}

function RegulatorsRating({ rating, ratingLabel, regulatoryBody }) {
  return (
    <>
      <div className={classNames(regulatorsRatingContainer)}>
        <InlineText>
          <Icon
            className={classNames(
              icon,
              RATING_ICON_CLASS?.[regulatoryBody]?.[rating],
            )}
            icon={RATING_ICON?.[regulatoryBody]?.[rating]}
          />
        </InlineText>

        <BodyText>
          <InlineText semibold>
            {useRatingCopy(regulatoryBody, rating)}
          </InlineText>
          <InlineText light>
            {ratingLabel && " - Regulator's rating"}
          </InlineText>
        </BodyText>
      </div>
    </>
  )
}

RegulatorsRating.propTypes = {
  rating: PropTypes.oneOf([...RATING_KEYS.ci, ...RATING_KEYS.cqc]),
  ratingLabel: PropTypes.bool,
  regulatoryBody: PropTypes.oneOf(["ci", "cqc"]).isRequired,
}

RegulatorsRating.defaultProps = {
  ratingLabel: false,
  rating: null,
}

export default RegulatorsRating
